/**
 * Web Service handler to retrieve and represent a list of services
 * at a location or Merchant
 *
 * @class ServicesWS
 */
var ServicesWS = function (viewModel, queuesWS) {
  var self = this;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.call(this, viewModel);

  self.name = "ServicesWS";
  self.queuesWS = queuesWS;
  self.previousServices = [];

  // This is a list of default colors to be applied to service
  // (queue/transaction types). These can be over-ridden with a custom
  // CSS. These colors present an array of RGB values
  self.colorList = ['#FE4273', '#E3723E', '#E6FE47', '#85CD01', '#40AED1', '#DB00B2', '#B30D2f', '#C53D18', '#ECC32A', '#AEC62F', '#2929A9', '#C581D9', '#FF8CAF', '#AF634B', '#EEE3A0', '#61CDA1', '#5A10EE', '#7D60A9', '#e&ABC4', '#553732', '#E3D63F', '#465D46', '#A8D7FE', '#C33FEF', '#B93B66', '#F65F00', '#F3EA8E', '#D3EAB7', '#3BF7F0', '#F68FE5'];


	/**
	 * API endpoint - never called
	 *
	 * @method serviceURL
	 * @return {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/calendar/services/';
  });

  /**
   * Returns a collection of services from the availableAppointments
   *
   * @method services
   * @return {Array}
   */
  self.services = ko.computed(function () {
    // This variable forces a computation when changed
    var availableAppointments = self.parent.appointmentsWS.availableAppointments();

    var servicesUsedByAvailableAppointments = availableAppointments.reduce(
      function (distinctTransactionTypes, appointment) {
        var canAdd = true;

        // Walk over the array of already stored transaction types
        // If the current item's id is not found in the return array
        // then we can add the new TT to the array.
        // This could be later enhanced with a Array.unique() function
        distinctTransactionTypes.forEach(function (transactionType) {
          if (
            Number(transactionType.id) ===
            Number(appointment.transactionType.id)
          ) {
            canAdd = false;
          }
        });

        if (appointment.transactionType && canAdd) {
          // Appointment Headers (Shallow) don't have the Transaction Type
          // description. We can glean it from the Queue's data.
          transactionTypeName = function (appointment) {
            var description = "";

            if (!appointment.transactionType.description) {
              var queue = self.queuesWS.getQueue(appointment.queueId);
              var indexedTransactionType = queue.indexedTransactionTypes()[
                appointment.transactionType.id
              ];

              description =
                indexedTransactionType &&
                indexedTransactionType.description !== undefined
                  ? indexedTransactionType.description
                  : "";

            } else {
              description = appointment.transactionType.description;
            }

            return description;
          };

          distinctTransactionTypes.push({
            name: transactionTypeName(appointment),
            id: appointment.transactionType.id,
          });
        }

        return distinctTransactionTypes;
      },
      []
    );

    self.parent.selectedServices(
      servicesUsedByAvailableAppointments.reduce(function (
        serviceIds,
        transactionType
      ) {
        serviceIds.push(transactionType.id.toString());
        return serviceIds;
      },
      [])
    );

    self.previousServices = servicesUsedByAvailableAppointments;

    return servicesUsedByAvailableAppointments;
  });

	/**
	* Returns the index of a TT within the services collection
	*
	* @method getServiceIndex
	* @param {Number} transactionTypeId the Transaction Type ID
	* @return {Number}
	*/
  self.getServiceIndex = function (transactionTypeId) {
    var index = -1;
    var services = self.previousServices;


    services.forEach(function (svc, idx) {
      if (Number(svc.id) == Number(transactionTypeId)) {
        index = idx;
      }
    });

    return index;
  };

  return self;
};

ServicesWS.prototype = AbstractWS.prototype;
ServicesWS.prototype.constructor = ServicesWS;
